// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bDpi","left":"styles_left__2CSGp","desktopActions":"styles_desktopActions__mENIb","title":"styles_title__utkEP"};